import { render, staticRenderFns } from "./ProjectGroupActivityTable.vue?vue&type=template&id=786a723e"
import script from "./ProjectGroupActivityTable.vue?vue&type=script&lang=js"
export * from "./ProjectGroupActivityTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports